import * as React from 'react';
import * as Styled from './single-select.styles';
export const SingleSelect = ({ children, selected, ...props }) => (React.createElement(Styled.SingleSelect, { "data-xds": "SingleSelect", "$selected": selected, ...props }, children));
//# sourceMappingURL=single-select.js.map